export const API_REALM = process.env.REACT_APP_API_REALM
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID
export const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL
export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
export const REACT_APP_STRAPI_URL = process.env.REACT_APP_STRAPI_URL
export const REACT_APP_STRAPI_API_URL = process.env.REACT_APP_STRAPI_API_URL
